export default __webpack_public_path__ + "static/media/success-jc-signup.a6028866.svg";